import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CustomLink from "components/CustomLink";

import { EXTERNAL_ROUTES } from "config/routes";

const SectionPoapCreate: FC = () => {
  return (
    <Box>
      <Typography variant="h5">
        <Box component="span" sx={{ fontWeight: 400 }}>
          Click here to set up POAP on your Item:{" "}
          <CustomLink
            href={EXTERNAL_ROUTES.POAP_SETUP}
            color="secondary"
            target="_blank"
            rel="noreferrer"
          >
            Instruction Link
          </CustomLink>
        </Box>
      </Typography>
    </Box>
  );
};

export default SectionPoapCreate;
